import joi from 'joi';

export const collection = joi.object({
	schema: joi.string(),
	id: joi.string(),
	url: joi.string(),
	uuid: joi.string(),
	instanceId: joi.string(),
	revision: joi.object({
		id: joi.string(),
		url: joi.string(),
	}),
	job: joi.object({
		id: joi.string(),
		url: joi.string(),
	}),
	form: joi.object({
		id: joi.string(),
		url: joi.string(),
	}),
	createdAt: joi.string(),
	collectedAt: joi.string(),
	collectedBy: joi.object({
		id: joi.string(),
		url: joi.string(),
	}),
	collectedWith: joi.string(),
	updatedAt: joi.string(),
	updatedBy: joi.object({
		id: joi.string(),
		url: joi.string(),
	}),
	fields: joi.array().items(
		joi.object({
			field: joi.string(),
			name: joi.string(),
			type: joi.string(),
			value: joi.any(),
		})
	),
	captures: joi.array().items(
		joi.object({
			explanation: joi.string().default('All the capture information goes here'),
		})
	),
	measurements: joi.object({
		explanation: joi.string().default('All the measurement information goes here'),
	}),
	brightnessCorrections: joi.object({
		explanation: joi.string().default('All the brightness adjustments information goes here'),
	}),
	cropParameters: joi.object({
		explanation: joi.string().default('All the image crop information goes here'),
	}),
});
